import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Home, Bed, Phone, User, LogOut, LogIn, UserPlus, Calendar } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import AuthModal from './AuthModal'
import MisReservas from './MisReservas'
import logo from '../assets/logo.svg'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const [showMisReservas, setShowMisReservas] = useState(false)
  const location = useLocation()
  const { user, isAuthenticated, logout } = useAuth()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const isActive = (path) => {
    return location.pathname === path ? 'active' : ''
  }

  return (
    <header className="header">
      <div className="header-overlay"></div>
      <div className="container">
        <div className="header-content">
          <Link 
            to="/" 
            className="logo"
            onClick={(e) => {
              if (location.pathname === '/') {
                e.preventDefault()
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }
              setIsMenuOpen(false)
            }}
          >
            <img src={logo} alt="Checkin24" className="logo-image" />
            <span className="logo-text">Checkin24</span>
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                {location.pathname === '/' ? (
                  <a 
                    href="#top"
                    className={`nav-link ${isActive('/')}`}
                    onClick={(e) => {
                      e.preventDefault()
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                      setIsMenuOpen(false)
                    }}
                  >
                    <Home size={20} />
                    Inicio
                  </a>
                ) : (
                  <Link 
                    to="/" 
                    className={`nav-link ${isActive('/')}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <Home size={20} />
                    Inicio
                  </Link>
                )}
              </li>
              <li>
                {location.pathname === '/' ? (
                  <a 
                    href="#habitaciones" 
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault()
                      const el = document.getElementById('habitaciones')
                      if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                      }
                      setIsMenuOpen(false)
                    }}
                  >
                    <Bed size={20} />
                    Habitaciones
                  </a>
                ) : (
                  <Link 
                    to="/#habitaciones" 
                    className={`nav-link ${isActive('/habitaciones')}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <Bed size={20} />
                    Habitaciones
                  </Link>
                )}
              </li>
              <li>
                <a 
                  href="#contacto" 
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault()
                    const el = document.getElementById('contacto')
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }
                    setIsMenuOpen(false)
                  }}
                >
                  <Phone size={20} />
                  Contacto
                </a>
              </li>
            </ul>
            
            <div className="header-cta">
              {isAuthenticated ? (
                <div className="user-menu-container">
                  <button 
                    className="user-menu-trigger"
                    onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                  >
                    {user?.picture ? (
                      <img 
                        src={user.picture} 
                        alt={user.name} 
                        className="user-avatar"
                      />
                    ) : (
                      <User size={20} />
                    )}
                    <span className="user-name">{user?.name}</span>
                  </button>
                  
                  {isUserMenuOpen && (
                    <div className="user-menu-dropdown">
                      <div className="user-info">
                        <p className="user-email">{user?.email}</p>
                      </div>
                      <button 
                        className="menu-item-btn"
                        onClick={() => {
                          setShowMisReservas(true);
                          setIsUserMenuOpen(false);
                        }}
                      >
                        <Calendar size={16} />
                        Mis Reservas
                      </button>
                      <button 
                        className="logout-btn"
                        onClick={() => {
                          logout();
                          setIsUserMenuOpen(false);
                        }}
                      >
                        <LogOut size={16} />
                        Cerrar Sesión
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                null // Ocultado temporalmente: login/registro se habilitarán más adelante
              )}
            </div>
          </nav>
          
          <button 
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />
      
      {/* Botón de acceso rápido en móvil ocultado temporalmente */}

      {/* Modal de Mis Reservas */}
      {showMisReservas && (
        <div className="modal-overlay" onClick={() => setShowMisReservas(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Mis Reservas</h2>
              <button 
                className="modal-close-btn"
                onClick={() => setShowMisReservas(false)}
              >
                <X size={24} />
              </button>
            </div>
            <div className="modal-body">
              <MisReservas />
            </div>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header